import React from 'react'
import PropTypes from 'prop-types'
import { formatterMoney } from 'utils/format'
import {
  BarChart as Chart,
  Bar,
  XAxis,
  Legend,
  Tooltip,
  ReferenceLine,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';

export default function BarChart({ report }) {
  const formatValue = (value) => (
    formatterMoney(Math.abs(value))
  )

  return report ? (
    <ResponsiveContainer width="100%" height="100%">
      <Chart
        data={report}
        width={1000}
        height={600}
        stackOffset="sign"
      >
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip formatter={formatValue} />
        <XAxis dataKey="name" />
        <Legend />
        <ReferenceLine y={0} stroke="#9e9e9e" />
        <Bar
          stackId="report"
          dataKey="total_used_vouchers"
          fill="#ff9800"
          name="Pago com voucher"
        />
        <Bar
          stackId="report"
          dataKey="total_generated_vouchers"
          fill="#4caf50"
          name="Vouchers gerados"
        />
        <Bar
          stackId="report"
          dataKey="total_discount"
          fill="#e3650b"
          name="Descontos"
        />
        <Bar
          stackId="report"
          dataKey="total"
          fill="#2196f3"
          name="Total"
        />
      </Chart>
    </ResponsiveContainer>
  ) : null
}

BarChart.propTypes = {
  report: PropTypes.objectOf(PropTypes.any),
}

BarChart.defaultProps = {
  report: null,
}
